import { AxiosError } from "axios";
export function getMappedLinkedAccounts(accounts) {
    const linkedAcc = [];
    if (accounts.length > 0) {
        accounts.forEach((acc) => {
            const linkedAccObj = {
                id: acc.userAccountID,
                fipId: acc.fipID,
                linkRefNumber: acc.linkRefNumber,
                maskedAccNumber: acc.maskedAccountNumber,
                accRefNumber: acc.accountRefNumber,
                FIType: acc.fiType,
                accType: acc.accountType,
                status: acc.status,
            };
            linkedAcc.push(linkedAccObj);
        });
        return linkedAcc;
    }
    else {
        return [];
    }
}
export function getConsentRequestDetailsMapped(consentResponse) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const data = (_a = consentResponse === null || consentResponse === void 0 ? void 0 : consentResponse.consents) === null || _a === void 0 ? void 0 : _a[0];
    return {
        status: "SUCCESS",
        ver: data.ver,
        txnid: data.txn_id,
        consentStatus: data.status,
        createTime: data.created_at,
        startTime: data.consent_start,
        expireTime: data.consent_expiry,
        statusLastupdateTimestamp: data.time_stamp,
        FIP: null,
        // AA: {
        //   id: data.ConsentDetail.consentUseLogUri,
        // },
        FIU: { id: data.fiuID, name: data.fiu_name },
        User: { id: data.ref_user_id },
        Accounts: getMappedLinkedAccounts((consentResponse === null || consentResponse === void 0 ? void 0 : consentResponse.Accounts) || []),
        ConsentUse: null,
        DataAccess: null,
        Purpose: (_c = (_b = consentResponse === null || consentResponse === void 0 ? void 0 : consentResponse.info) === null || _b === void 0 ? void 0 : _b.ConsentDetail) === null || _c === void 0 ? void 0 : _c.Purpose,
        Signature: null,
        mode: data.consent_mode,
        fetchType: data.fetch_type,
        consentTypes: (_d = consentResponse === null || consentResponse === void 0 ? void 0 : consentResponse.info) === null || _d === void 0 ? void 0 : _d.ConsentDetail.consentTypes,
        consentDisplayDescriptions: (_e = data.consent_types) === null || _e === void 0 ? void 0 : _e.split(","),
        fiTypes: (_g = (_f = consentResponse === null || consentResponse === void 0 ? void 0 : consentResponse.info) === null || _f === void 0 ? void 0 : _f.ConsentDetail) === null || _g === void 0 ? void 0 : _g.fiTypes,
        DataDateTimeRange: (_h = consentResponse === null || consentResponse === void 0 ? void 0 : consentResponse.info) === null || _h === void 0 ? void 0 : _h.ConsentDetail.FIDataRange,
        DataLife: (_j = consentResponse === null || consentResponse === void 0 ? void 0 : consentResponse.info) === null || _j === void 0 ? void 0 : _j.ConsentDetail.DataLife,
        Frequency: (_k = consentResponse === null || consentResponse === void 0 ? void 0 : consentResponse.info) === null || _k === void 0 ? void 0 : _k.ConsentDetail.Frequency,
        DataFilter: (_l = consentResponse === null || consentResponse === void 0 ? void 0 : consentResponse.info) === null || _l === void 0 ? void 0 : _l.ConsentDetail.DataFilter,
        consentDetailDigitalSignature: null,
        ConsentHandle: data.consent_handle,
    };
}
export function handleErrors(error, aaOperation, attempt) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (error instanceof AxiosError && !error.response) {
        switch (error.code) {
            case AxiosError.ECONNABORTED:
                return {
                    message: "Connection to server lost. Please try again after sometime",
                    status: "AA_ERROR",
                    statusCode: "CONNECTION_LOST",
                    aaOperation,
                    attempt
                };
            case AxiosError.ERR_BAD_OPTION:
            case AxiosError.ERR_BAD_OPTION_VALUE:
                return {
                    message: "Request option is invalid",
                    status: "AA_ERROR",
                    statusCode: "INVALID_REQUEST_OPTION",
                    aaOperation,
                    attempt
                };
            case AxiosError.ERR_BAD_REQUEST:
            case AxiosError.ERR_BAD_RESPONSE:
                return {
                    message: "Invalid Data in request or response.",
                    status: "AA_ERROR",
                    statusCode: "INVALID_REQUEST_RESPONSE",
                    aaOperation
                };
            case AxiosError.ERR_CANCELED:
                return {
                    message: "Request got cancelled as it took too much of time.",
                    status: "AA_ERROR",
                    statusCode: "REQUEST_CANCELLED",
                    aaOperation,
                    attempt
                };
            case AxiosError.ERR_DEPRECATED:
                return {
                    message: "Deprecated method used",
                    status: "AA_ERROR",
                    statusCode: "DEPRECATED",
                    aaOperation
                };
            case AxiosError.ERR_FR_TOO_MANY_REDIRECTS:
                return {
                    message: "Redirection to your site happened many times.",
                    status: "AA_ERROR",
                    statusCode: "TOO_MANY_REDIRECTS",
                    aaOperation,
                    attempt
                };
            case AxiosError.ERR_INVALID_URL:
                return {
                    message: "Invalid URL",
                    status: "AA_ERROR",
                    statusCode: "INVALID_URL",
                    aaOperation
                };
            case AxiosError.ERR_NETWORK:
                return {
                    message: "Some issue with your network. Retry again or change your network.",
                    status: "AA_ERROR",
                    statusCode: "NETWORK_ISSUE",
                    aaOperation,
                    attempt
                };
            case AxiosError.ERR_NOT_SUPPORT:
                return {
                    message: "The https request is not suported.",
                    status: "AA_ERROR",
                    statusCode: "NOT_SUPPORTED",
                    aaOperation
                };
            case AxiosError.ETIMEDOUT:
                return {
                    message: "The request got timed out as it took much more time than expected.Please try after sometime.",
                    status: "AA_ERROR",
                    statusCode: "TIMED_OUT",
                    aaOperation,
                    attempt
                };
        }
    }
    if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) !== 401) {
        return {
            message: (_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.errorCode,
            status: "FAILURE",
            errorCode: ((_e = (_d = error === null || error === void 0 ? void 0 : error.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.errorCode) || "",
            statusCode: (_f = error === null || error === void 0 ? void 0 : error.response) === null || _f === void 0 ? void 0 : _f.status,
            aaOperation,
            attempt
        };
    }
    else {
        return {
            message: (error === null || error === void 0 ? void 0 : error.message) || "Some Error Occured. Please try again after some time.",
            status: "FAILURE",
            errorCode: ((_h = (_g = error === null || error === void 0 ? void 0 : error.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.errorCode) || "",
            statusCode: (_j = error === null || error === void 0 ? void 0 : error.response) === null || _j === void 0 ? void 0 : _j.status,
            aaOperation,
            attempt
        };
    }
}
export function isFIPAvailable(fipList, fipId) {
    if (Array.isArray(fipList) && fipList.length > 0) {
        return !!fipList.find(fip => fip.fipID === fipId);
    }
    return false;
}
//# sourceMappingURL=index.js.map